import React, { useState } from "react";
import { withFormik, Form, Field } from "formik";
import * as Yup from "yup";
import { FormGroup, Label, Button, Col, Row, Card, Input } from "reactstrap";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import { PostSupervisorCompany } from "../../actions/teacherMutations";
import { useMutation, useQueryClient } from "react-query";
import { GetSupervisorCompanies } from "../../actions/teacherQueries";
import Pacmanloader from "../../components/Pacmanloader/Pacmanloader";
import { FormattedMessage } from "react-intl";
import PromptAddSupervisorToSchool from "../Modal/PromptAddSupervisorToSchool";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const CreateNewSupervisor = (props) => {
  const { values, errors, touched, isSubmitting, dismissModal } = props;
  const [addNewCompany, setAddNewCompany] = useState(false);
  const [newCompanyName, setNewCompanyName] = useState("");

  const postSupervisorCompanyMutation = useMutation(PostSupervisorCompany);
  const companies = GetSupervisorCompanies();
  const queryClient = useQueryClient();

  if (companies.isLoading) {
    return <Pacmanloader />;
  }
  const companiesList = () => {
    let tempList = [];
    companies.data.forEach((c) => {
      let companyToAdd = { value: c, label: c.name };
      tempList.push(companyToAdd);
    });
    let addNewCompany = {
      value: { id: "Add" },
      label: "Lägg till nytt företag",
    };
    tempList.unshift(addNewCompany);
    return tempList;
  };

  const handleSetCompany = (val) => {
    if (val === "Add") {
      setAddNewCompany(true);
    } else {
      values.supervisorCompanyId = val;
    }
  };

  const handleSubmitNewCompany = () => {
    let cleanedCompanyName = newCompanyName.replace("&", "%26");
    postSupervisorCompanyMutation.mutate(cleanedCompanyName, {
      onSuccess: (data) => {
        if (data && data.status > 199 && data.status < 300) {
          toast.success("Företag tillagt");
          queryClient.invalidateQueries("FetchSupervisorCompanies");
        } else {
          toast.warn(data);
        }
        setAddNewCompany(false);
      },
      throwOnError: true,
      onError: (data) => {
        toast.warn(data.response.data);
      },
    });
  };

  return (
    <Card className="p-2">
      <Form>
        <Row>
          <Col lg={6}>
            <FormGroup>
              <Label>
                <FormattedMessage id="Name" />
              </Label>
              <Field
                className={`form-control ${
                  errors.supervisorName &&
                  touched.supervisorName &&
                  "is-invalid"
                }`}
                type="input"
                name="supervisorName"
                placeholder="Namn"
                defaultValue={values.supervisorName}
              />
              {errors.supervisorName && touched.supervisorName && (
                <div className="invalid-feedback">{errors.supervisorName}</div>
              )}
            </FormGroup>
          </Col>
          <Col lg={6}>
            <FormGroup>
              <Label>
                <FormattedMessage id="Email" />
              </Label>
              <Field
                className={`form-control ${
                  errors.supervisorEmail &&
                  touched.supervisorEmail &&
                  "is-invalid"
                }`}
                type="input"
                name="supervisorEmail"
                placeholder="Epost"
                defaultValue={values.supervisorEmail}
              />
              {errors.supervisorEmail && touched.supervisorEmail && (
                <div className="invalid-feedback">{errors.supervisorEmail}</div>
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col lg={6}>
            <FormGroup>
              <Label>
                <FormattedMessage id="Phone" />{" "}
              </Label>
              <Field
                className={`form-control ${
                  errors.supervisorPhone &&
                  touched.supervisorPhone &&
                  "is-invalid"
                }`}
                type="input"
                name="supervisorPhone"
                placeholder="Telefon"
                defaultValue={values.supervisorPhone}
              />
              {errors.supervisorPhone && touched.supervisorPhone && (
                <div className="invalid-feedback">{errors.supervisorPhone}</div>
              )}
            </FormGroup>
          </Col>
          <Col lg={6}>
            {!addNewCompany ? (
              <FormGroup>
                <Label for="supervisorCompany">
                  <FormattedMessage id="Company" />
                </Label>
                <Field
                  component="select"
                  name="supervisorCompanyId"
                  id="supervisorCompany"
                  onChange={(val) => handleSetCompany(val.target.value)}
                  value={companiesList().find(
                    (c) => c.value.id === values.supervisorCompanyId
                  )}
                  className={`form-control ${
                    errors.supervisorCompanyId &&
                    touched.supervisorCompanyId &&
                    "is-invalid"
                  }`}
                >
                  <option value="-1" key="-1">
                    Välj företag från listan
                  </option>
                  {companiesList().map((c, i) => {
                    return (
                      <option key={c.value.id} value={c.value.id}>
                        {c.label}
                      </option>
                    );
                  })}
                </Field>
                {errors.supervisorCompanyId && touched.supervisorCompanyId && (
                  <div className="invalid-feedback">
                    {errors.supervisorCompanyId}
                  </div>
                )}
              </FormGroup>
            ) : (
              <>
                <Label for="CreatedCompanyName">
                  <FormattedMessage id="AddCompany" />
                </Label>
                <Row className="m-0 p-0">
                  <Input
                    type="text"
                    value={newCompanyName}
                    onChange={(data) => setNewCompanyName(data.target.value)}
                  />
                </Row>
                <Row className="m-0 p-0">
                  <Col lg={6} className="p-0">
                    <Button
                      outline
                      className="p-1 mt-1"
                      color="secondary"
                      onClick={() => setAddNewCompany(false)}
                    >
                      <FormattedMessage id="Cancel" />
                    </Button>
                  </Col>
                  <Col lg={6} className="p-0">
                    <Button
                      onClick={() => handleSubmitNewCompany()}
                      outline
                      className="p-1 mt-1"
                      color="primary"
                    >
                      <FormattedMessage id="Add" />
                    </Button>
                  </Col>
                </Row>
              </>
            )}
          </Col>
        </Row>

        <Button
          outline
          color="primary"
          type="submit"
          disabled={isSubmitting}
          className="m-2 float-end"
        >
          {isSubmitting ? (
            <FormattedMessage id="Wait" />
          ) : (
            <FormattedMessage id="AddPersons" />
          )}
        </Button>
        <Button
          outline
          className="m-2 float-start"
          color="secondary"
          type="button"
          onClick={dismissModal}
        >
          <FormattedMessage id="Cancel" />
        </Button>
      </Form>
      <PromptAddSupervisorToSchool
        supervisor={props.supervisorToAddToSchool}
        toggle={props.toggleAddToSchool}
        isOpen={props.addToSchoolIsOpen}
        dismissModal={dismissModal}
        schoolId={props.schoolId}
        setSubmitting={props.setSubmitting}
      />
    </Card>
  );
};

const FormikForm = withFormik({
  mapPropsToValues: (props) => ({
    supervisorName: props.supervisorName,
    supervisorEmail: props.supervisorEmail,
    supervisorPhone: props.supervisorPhone,
    supervisorCompanyId: props.supervisorCompanyId,
  }),
  validationSchema: Yup.object().shape({
    supervisorName: Yup.string().required("Nödvändigt"),
    supervisorEmail: Yup.string()
      .email("Måste vara en giltig epost")
      .max(255)
      .required("Epost är nödvändig"),
    supervisorCompanyId: Yup.number()
      .typeError("Handledaren måste ha ett företag")
      .required("Handledaren måste ha ett företag")
      .positive("Handledaren måste ha ett företag"),
  }),

  handleSubmit(values, { props, resetForm, setSubmitting }) {
    let supervisor = {
      Name: values.supervisorName,
      Email: values.supervisorEmail,
      Phone: values.supervisorPhone,
      CompanyId: values.supervisorCompanyId,
      VisibleForSchoolId: props.schoolId,
    };
    axios
      .post(`/Apl/PostSupervisorForSchool`, supervisor)
      .then((res) => {
        if (res.data.result.createdUser) {
          let supervisorToAdd = {
            value: res.data.result.createdUser,
            label:
              res.data.result.createdUser.name +
              " - " +
              res.data.result.createdUser.aplCompany.name,
          };
          props.setSelectableSupervisors([
            ...props.selectableSupervisors,
            supervisorToAdd,
          ]);
          axios
            .post(
              `/User/SendActivationMail?email=${encodeURIComponent(
                supervisor.Email
              )}`
            )
            .then(() => {
              toast.success("Handledare har skapats", TOAST_CONFIG);
              resetForm();
            })
            .catch((err) => {
              toast.warn(
                `Det gick inte att skicka ut ett nytt aktiveringsmail till användaren`
              );
            });
          props.dismissModal();
        } else if (res.data.result.alreadyExistingUser) {
          if (
            res.data.result.alreadyExistingUser.userTypeOf !== "AplSupervisor"
          ) {
            toast.warn(
              "Användare finns redan i systemet och är inte handledare"
            );
          } else {
            props.setSupervisorToAddToSchool(
              res.data.result.alreadyExistingUser
            );
            props.setAddToSchoolIsOpen(true);
          }
        }
      })
      .catch((err) => {
        toast.error(
          err.response ? err.response.data : err.message,
          TOAST_CONFIG
        );
        props.dismissModal();
      });
    props.handleReloadSupervisors();
    setSubmitting(false);
  },
})(CreateNewSupervisor);

export default FormikForm;
